import { gql } from '@apollo/client';
import useGQLMutation from 'src/lib/graphql/hooks/useGQLMutation';
import { NOTES_LIST_QUERY } from './getList';
const CREATE_NOTE_MUTATION = gql `
  mutation Admin_CreateNote($data: EPNoteCreateInput!) {
    ep_createNote(data: $data) {
      id
      data {
        title
        topics
        slug
      }
      ctime
      utime
    }
  }
`;
export function useCreateNoteMutation(options) {
    return useGQLMutation(CREATE_NOTE_MUTATION, {
        ...options,
        update(cache, { data }, { variables }) {
            if (data?.ep_createNote && variables) {
                cache.updateQuery({
                    query: NOTES_LIST_QUERY,
                    variables: {
                        pagination: {
                            offset: 0,
                        }
                    }
                }, ({ ep_noteList: existingData }) => {
                    return {
                        ep_noteList: {
                            ...existingData,
                            totalCount: existingData.totalCount + 1,
                            list: [{
                                    ...data.ep_createNote,
                                    __typename: 'EPNote',
                                }, ...existingData.list],
                        },
                    };
                });
            }
        }
    });
}
